import { ColorToken } from "@flash-tecnologia/hros-web-ui-v2";
import { useMemo } from "react";
import * as SC from "./number.styles";

export interface NumberProps extends SC.NumberWrapperProps {
  children?: string;
  onClick?: () => void;
}

export const Number = ({ children, size, variant, onClick }: NumberProps) => {
  const textColor = useMemo(() => {
    return {
      active: "neutral.100",
      default: "neutral.50",
    }[variant] as ColorToken;
  }, [variant]);

  return (
    <SC.NumberWrapper size={size} variant={variant} onClick={onClick}>
      <SC.NumberLabel variant="body4" color={textColor}>
        {children}
      </SC.NumberLabel>
    </SC.NumberWrapper>
  );
};
